<template>
  <h1>504 Testing</h1>
  <hr />
  發送次數： {{ count }}<br />
  失敗次數： {{ fail }}<br />
  錯誤次數： {{ error }}
  <hr />
  <div v-for="(m, count) in log" :key="count" class="log">{{ m }}</div>
</template>

<script>
export default {
  data() {
    return {
      count: 0,
      fail: 0,
      error: 0,
      log: [],
      jwt: null,
      timeout: 0,
      timer: null,
      interval: 1 * 1000
    };
  }, //datad
  computed: {},
  mounted() {
    this.getData();
    this.timer = setInterval(this.getData, this.interval);
  },
  methods: {
    getData() {
      this.$http
        .post(`/api/utils/Testing?count=${this.count}`, {
          platform: "line",
          action: "scan",
          jwt: this.jwt,
          count: this.count
        })
        .then(response => {
          console.log(response.data);
          this.response = response.data; //Debug用
          this.jwt = response.data.jwt;
          this.loading = false;
          if (response.data.code !== "success") {
            this.fail++;
          }
        })
        .catch(error => {
          this.error++;
          let d = new Date().toLocaleTimeString();
          this.log.push(`${this.count}: ${error.message}. ${d}`);
        });
      this.count++;
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped>
.log {
  padding: 3px 12px;
  font-size: 10px;
}
</style>
